import stories from './stories'

function extractNode(parent, story) {
    const path = `${parent}${story.name.replaceAll(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`

    const node = {
        path: path,
        display: story.name,
        component: story.component,
    }

    if (story.children) {
        node.children = story.children.map(c => extractNode(path + '/', c))
    }

    return node
}

var tree = stories.map(s => extractNode('', s))

export default tree
